import React, { useState, useEffect } from 'react';
import {
  Modal, Input, Form, Row, Col, Typography,
} from 'antd';
import { platformApi } from '../../../../api';
import { formatValue } from '../../../../utils'

const { Item } = Form;
const { Text, Title } = Typography;

const SACForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);
  const [error, setError] = useState({})

  const {
    form, open, close, data, modify
  } = props;
  const { getFieldDecorator } = form;

  useEffect(() => {
    setEditable(props.editable);
    if (data) {
      form.setFieldsValue({
        code: data.code,
        description: data.description,
        cess: data.cess,
        cgst: data.cgst,
        sgst: data.sgst,
        igst: data.igst,
      });
    }
  }, [data, props.editable]);

  const handleSubmit = () => {
    form.validateFields(async (validationError) => {
      if (validationError === null && !error.CESS && !error.IGST && !error.SAC) {
        setLoading(true);
        const code = form.getFieldValue('code');
        const description = form.getFieldValue('description');
        const cess = parseFloat(form.getFieldValue('cess'));
        const cgst = parseFloat(form.getFieldValue('cgst'));
        const sgst = parseFloat(form.getFieldValue('sgst'));
        const igst = parseFloat(form.getFieldValue('igst'));
        const createdAt = new Date().toLocaleDateString();
        const SAC = {
          code, description, cess, cgst, sgst, igst, createdAt,
        };
        data ? (SAC.id = data.id) : {};
        await props.emitData(SAC);
        setLoading(false);
        form.resetFields();
        props.close();
      }
    });
  };

  const calculateGST = (event) => {
    const IGST = event.target.value;
    form.setFieldsValue({
      cgst: IGST / 2,
      sgst: IGST / 2,
    });
  };

  return (
    <Modal
      title={<Title level={4}>SAC Code</Title>}
      visible={open}
      okText={editable ? 'Save' : 'Modify'}
      onCancel={() => {
        form.resetFields();
        close();
        setError({})
      }}
      okButtonProps={{ loading, disabled: !modify }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
    >
      <Form>
        <Row type="flex" justify="space-between">
          <Col span={10}>
            <Item
              label={<Text>SAC Code</Text>}
              colon={false}
              required
              validateStatus={error.SAC && error.SAC.type}
              help={error.SAC && error.SAC.message}
            >
              {getFieldDecorator('code', {
                rules: [{ required: true, message: 'Enter SAC code' }],
              })(
                <Input
                  onWheel={(event) => event.currentTarget.blur()}
                  disabled={!editable}
                  placeholder="SAC code"
                  maxLength={15}
                  pattern="^[0-9]{1,12}$"
                  onInput={(event) => {
                    if (!event.target.checkValidity()) {
                      setError({
                        ...error,
                        SAC: {
                          type: "error",
                          message: "Enter Valid SAC!"
                        }
                      })
                    } else {
                      delete error.SAC
                      setError(error)
                    }
                  }}
                />,
              )}
            </Item>
          </Col>
          <Col span={10}>
            <Item
              label={<Text>IGST</Text>}
              colon={false} required
              validateStatus={error.IGST && error.IGST.type}
              help={error.IGST && error.IGST.message}
            >
              {getFieldDecorator('igst', {
                rules: [{ required: true, message: 'Enter IGST' }],
              })(
                <Input
                  addonAfter="%"
                  // maxLength={4}
                  onKeyUp={e => {
                    form.setFieldsValue({
                      igst: formatValue(e, "noWithDot")
                    })
                    if (form.getFieldValue("igst").length == 0) {
                      delete error.IGST
                    }
                  }}
                  onWheel={(event) => event.currentTarget.blur()}
                  onChange={calculateGST}
                  disabled={!editable}
                  placeholder="IGST"
                  maxLength={6}
                  pattern="[0-9]+(\.[0-9][0-9]?)?"
                  onInput={(event) => {
                    if (!event.target.checkValidity()) {
                      setError({
                        ...error,
                        IGST: {
                          type: "error",
                          message: "Enter Valid IGST!"
                        }
                      })
                    } else {
                      delete error.IGST
                      setError(error)
                    }
                  }}
                />,
              )}
            </Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span={10}>
            <Item
              label={<Text>Description</Text>}
              colon={false}

            >
              {getFieldDecorator('description', {
                rules: [{ required: false, message: 'Enter Description' }],
              })(
                <Input
                  onKeyUp={e => {
                    if (e.target.value) {
                      form.setFieldsValue({
                        description: formatValue(e, "firstCaps")
                      })
                    }
                  }
                  }
                  disabled={!editable}
                  placeholder="Description"
                  maxLength={50}
                />)}
            </Item>
          </Col>
          <Col span={10}>
            <Item
              label={<Text>CGST</Text>}
              colon={false}
            >
              {getFieldDecorator('cgst', {
                rules: [{ required: false, message: 'Enter CGST' }],
              })(
                <Input
                  addonAfter="%"
                  type="number"
                  maxLength={6}
                  onWheel={(event) => event.currentTarget.blur()}
                  disabled
                  placeholder="CGST"
                />,
              )}
            </Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span={10}>
            <Item
              label={<Text>CESS</Text>}
              colon={false}
              validateStatus={error.CESS && error.CESS.type}
              help={error.CESS && error.CESS.message}
            >
              {getFieldDecorator('cess', {
                rules: [{ required: false, message: 'Enter Cess' }],
              })(
                <Input
                  // type="number"
                  addonAfter="%"
                  maxLength={6}
                  onWheel={(event) => event.currentTarget.blur()}
                  disabled={!editable}
                  onKeyUp={e => {
                    form.setFieldsValue({
                      cess: formatValue(e, "noWithDot")
                    })
                    if (form.getFieldValue("cess").length == 0) {
                      delete error.CESS
                    }
                  }}
                  placeholder="Cess"
                  // maxLength={5}
                  pattern="[0-9]+(\.[0-9][0-9]?)?"
                  onInput={(event) => {
                    if (!event.target.checkValidity()) {
                      setError({
                        ...error,
                        CESS: {
                          type: "error",
                          message: "Enter Valid CESS!"
                        }
                      })
                    } else {
                      delete error.CESS
                      setError(error)
                    }
                  }}
                />,
              )}
            </Item>
          </Col>
          <Col span={10}>
            <Item
              label={<Text>SGST</Text>}
              colon={false}
            >
              {getFieldDecorator('sgst', {
                rules: [{ required: false, message: 'Enter SGST' }],
              })(
                <Input
                  addonAfter="%"
                  type="number"
                  maxLength={6}
                  onWheel={(event) => event.currentTarget.blur()}
                  disabled
                  placeholder="SGST"
                />,
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedAccessoriesModal = Form.create({ name: 'normal_login' })(SACForm);

export default WrappedAccessoriesModal;
